import Clients from "./clients"

export default Clients
